import {
  Box,
  Button,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  Icon,
  Paper,
  Switch,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  CEPInput,
  DocumentInput,
  EmailInput,
  PhoneInput,
  TextFieldComponent,
} from "../../../../components/misc/form";
import { FRow } from "../../../../globalComponents/standard";
import useAlert from "../../../../globalComponents/useAlerts";
import ProductDetailsContext from "./context";
import MediaUpload from "../../../../components/mediaUpload";

const FormInfo = () => {
  const navigate = useNavigate();
  const { showLoading, showAlert, dismissLoading, showConfirmDialog } =
    useAlert();
  const [editing, setEditing] = useState(false);

  const { product: form, updateProduct } = useContext(ProductDetailsContext);

  const handleSubmit = async (_form) => {
    updateProduct(_form, () => setEditing(false));
  };

  const handleDeactive = () => {
    showConfirmDialog({
      title: "Confirme",
      description:
        "Deseja mesmo desativar esse produto? Todas as informações e vínculos com premiação serão invalidados após o processo.",
      onConfirm: () =>
        updateProduct({ active: false }, () => navigate("./../")),
    });
  };

  const refs = {};

  const {
    register,
    handleSubmit: formSubmit,
    control,
    setValue,
    setFocus,
    watch,
  } = useForm();

  const onUploadComplete = React.useCallback(([file]) => {
    setValue("imageFile", file);
  }, []);

  useEffect(() => {}, []);

  return (
    <Paper
      elevation={3}
      sx={{
        //width: 400,
        maxHeight: "100vh", // limit height
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        onSubmit={formSubmit(handleSubmit)}
        component="form"
        sx={{
          p: 2,
          overflowY: "auto", // 🔥 enables scroll
          flex: 1, // fills available space
        }}
      >
        <Grid container spacing={2} mt={1}>
          <Grid flexGrow={1}>
            <FRow fullWidth justifyContent="space-between">
              <Typography variant="h6" mb={2} gutterBottom>
                Produto
              </Typography>

              <FormGroup>
                <FormControlLabel
                  control={<Switch checked={editing} />}
                  label="Editar"
                  onChange={(_, checked) => setEditing(checked)}
                />
              </FormGroup>
            </FRow>
          </Grid>
          <Grid container size={{ xs: 12 }}>
            <Grid size={{ xs: 12, md: 4, lg: 4 }}>
              <Paper
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "5px",
                }}
              >
                <MediaUpload
                  preview={form.imageUrl}
                  forwardRef={(ref) => (refs.imageUrl = ref)}
                  onUploadComplete={onUploadComplete}
                  acceptTypes=".jpeg,.jpg,.png,.webp,"
                  style={{ maxHeight: 100 }}
                >
                  {({ onUploadRequest, media }) => (
                    <Button
                      onClick={() => {
                        if (editing) onUploadRequest();
                      }}
                    >
                      <div>
                        {media.thumbnail || (
                          <Icon
                            style={{
                              fontSize: 150,
                              alignSelf: "center",
                              color: "#ccc",
                            }}
                          >
                            add_photo_alternate
                          </Icon>
                        )}
                      </div>
                    </Button>
                  )}
                </MediaUpload>
              </Paper>
            </Grid>

            <Grid container size={{ xs: 12, md: 8, lg: 8 }}>
              <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                <TextFieldComponent
                  name="title"
                  disabled={!editing}
                  defaultValue={form.title}
                  control={control}
                  label={"Título"}
                  fullWidth
                  required
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                <TextFieldComponent
                  maxRows={6}
                  minRows={6}
                  multiline
                  disabled={!editing}
                  defaultValue={form.description}
                  name="description"
                  control={control}
                  label={"Descrição"}
                  fullWidth
                  required
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item flexGrow={1} size={{ xs: 12 }}>
            {editing && (
              <FRow fullWidth justifyContent="space-between">
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  sx={{ mt: 3 }}
                >
                  Salvar
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleDeactive}
                  sx={{ mt: 3 }}
                >
                  Desativar produto
                </Button>
              </FRow>
            )}
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Divider />
          </Grid>
          <Grid
            container
            justifyContent={"space-between"}
            size={{ xs: 12 }}
            flexGrow={1}
          >
            <Grid textAlign={"center"} size={{ xs: 12, md: 6, lg: 6 }}>
              <Typography variant="caption" color="textDisabled" gutterBottom>
                Cadastrado em: {new Date(form.createdAt).toLocaleString()}
                <br />({form.createdBy})
              </Typography>
            </Grid>
            <Grid textAlign={"center"} size={{ xs: 12, md: 6, lg: 6 }}>
              <Typography variant="caption" color="textDisabled" gutterBottom>
                Última alteração: {new Date(form.updatedAt).toLocaleString()}
                <br />({form.updatedBy})
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

export default React.memo(FormInfo);
